(function () {
  if (window.galleryCarouselLoaded) return;
  window.galleryCarouselLoaded = true;

  function shuffleSlides(wrapper) {
    var slides = Array.from(wrapper.children);

    for (var index = slides.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var currentSlide = slides[index];
      slides[index] = slides[randomIndex];
      slides[randomIndex] = currentSlide;
    }

    slides.forEach(function (slide) {
      wrapper.appendChild(slide);
    });
  }

  function setupLightbox(gallery) {
    var triggers = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
    if (!triggers.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'gallery-lightbox';
    if (triggers.length === 1) dialog.classList.add('gallery-lightbox--single');
    dialog.innerHTML =
      '<button class="gallery-lightbox__close" type="button" aria-label="Close image">&times;</button>' +
      '<button class="gallery-lightbox__previous" type="button" aria-label="Previous image">&#8249;</button>' +
      '<figure><img class="gallery-lightbox__image" alt=""><figcaption></figcaption></figure>' +
      '<button class="gallery-lightbox__next" type="button" aria-label="Next image">&#8250;</button>';
    document.body.appendChild(dialog);

    var image = dialog.querySelector('.gallery-lightbox__image');
    var caption = dialog.querySelector('figcaption');
    var activeIndex = 0;

    function showImage(index) {
      activeIndex = (index + triggers.length) % triggers.length;
      var trigger = triggers[activeIndex];
      var thumbnail = trigger.querySelector('img');
      image.src = trigger.href;
      image.alt = thumbnail ? thumbnail.alt : '';
      caption.textContent = trigger.dataset.caption || '';
      caption.hidden = !caption.textContent;
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function (event) {
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        showImage(index);
        dialog.showModal();
      });
    });

    dialog.querySelector('.gallery-lightbox__close').addEventListener('click', function () {
      dialog.close();
    });
    dialog.querySelector('.gallery-lightbox__previous').addEventListener('click', function () {
      showImage(activeIndex - 1);
    });
    dialog.querySelector('.gallery-lightbox__next').addEventListener('click', function () {
      showImage(activeIndex + 1);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  }

  function initGallery(gallery) {
    if (gallery.dataset.initialized === 'true' || gallery.dataset.initializing === 'true') return;

    var slider = gallery.querySelector('.snapslider-overflow');
    var slidesWrapper = gallery.querySelector('.swiper-wrapper');
    if (!slider || !slidesWrapper) return;

    gallery.dataset.initializing = 'true';

    if (gallery.dataset.randomize === 'true') {
      shuffleSlides(slidesWrapper);
    }

    setupLightbox(gallery);

    var swiper = new Swiper(slider, {
      cssMode: true,
      speed: 1000,
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-next'),
        prevEl: gallery.querySelector('.swiper-button-prev')
      },
      pagination: {
        el: gallery.querySelector('.swiper-pagination'),
        clickable: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      },
      slidesPerView: 'auto',
      mousewheel: true,
      keyboard: true
    });

    function finishInitialization() {
      gallery.dataset.initialized = 'true';
      delete gallery.dataset.initializing;
    }

    if (gallery.dataset.randomize === 'true') {
      // Reordering existing nodes can make the browser preserve the position of
      // the old first slide. Reset after layout so randomized slide 0 stays put.
      requestAnimationFrame(function () {
        swiper.slideTo(0, 0, false);
        slidesWrapper.scrollLeft = 0;

        requestAnimationFrame(function () {
          swiper.slideTo(0, 0, false);
          slidesWrapper.scrollLeft = 0;
          finishInitialization();
        });
      });
    } else {
      finishInitialization();
    }
  }

  function observeGallery(gallery) {
    if (gallery.dataset.observed === 'true') return;
    gallery.dataset.observed = 'true';

    if (!('IntersectionObserver' in window)) {
      initGallery(gallery);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      initGallery(gallery);
    }, { rootMargin: '600px 0px' });

    observer.observe(gallery);
  }

  function initAllGalleries(container) {
    if (container.matches && container.matches('[data-gallery-carousel]')) {
      observeGallery(container);
    }

    container.querySelectorAll('[data-gallery-carousel]').forEach(observeGallery);
  }

  function boot() {
    initAllGalleries(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllGalleries(event.target);
  });
})();
